import React from 'react';
import {Img} from "../Img";
import LanguageSwitcher from "../languageSwitcher";
import BurgerMenu from './BurgerMenu';

export default function HeaderWithBurger() {
    return (
        <div className="px-5 pt-5 sm:px-[16px] sm:pt-[22px] container-xs">
            <div className="flex items-center justify-between">
                {/* Логотип слева */}
                <Img src="/images/logo_header.svg"
                    className="w-[167px] h-5"/>

                <div className="flex items-center gap-4">
                    <LanguageSwitcher />
                    <BurgerMenu />
                </div>
            </div>
        </div>
    );
}
